import styled from 'styled-components';
import Dropdown from 'react-bootstrap/Dropdown';
import { theme } from '../../../theme';

export const SpanArrow = styled.span`
  position: absolute;
  top: 50%;
  right: 0.769rem;
  transform: translate(0, -50%);
  color: ${theme.colors.secondary};
  font-size: 1.538rem;

  .dropdown.show & {
    transform: translate(0, -50%) rotate(180deg);
  }
`;

export const DropdownToggle = styled(Dropdown.Toggle)`
  position: relative;
  width: 100%;
  white-space: pre-line !important;
  display: inline-block !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 0.8rem 2.461rem 0.67rem 1.078rem !important;
  font-size: 0.923rem;
  font-weight: 500 !important;
  text-align: left !important;
  border-radius: 5px;
  border: 1px solid ${theme.colors.secondary};
  color: ${theme.colors.textPrimary};
  background-color: ${theme.colors.white};
  outline: none;

  &.btn {
    justify-content: flex-start !important;
  }

  &.dropdown-toggle::after {
    display: none !important;
  }

  &:hover,
  &:active,
  &:focus,
  &.btn-outline-primary.dropdown-toggle {
    box-shadow: none !important;
    border: 1px solid ${theme.colors.secondary} !important;
    color: ${theme.colors.textPrimary} !important;
    background-color: ${theme.colors.white} !important;
  }
`;

export const DropdownMenu = styled(Dropdown.Menu)`
  width: 100%;
  padding: 0;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.box};
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;

  // To rewrite native styles
  & li.dropdown-item {
    padding: 0.655rem 1.5rem;
    color: ${theme.colors.textPrimary};
    font-size: 0.923rem;
    font-weight: 500;
    white-space: pre-line;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

    &.active {
      font-weight: 600;
    }

    &:hover,
    &.dropdown-item.active,
    &.dropdown-item:active,
    &.dropdown-item:focus {
      color: ${theme.colors.textPrimary} !important;
      background-color: ${theme.colors.surfaceBottom} !important;
    }
  }
`;

export const DivList = styled.div`
  max-height: 15.385rem;
  padding: 0.5rem 0;
`;

export const SpanSelection = styled.span`
  color: ${theme.colors.secondary};
  margin-right: 0.5rem;
`;

export const DivTitle = styled.div`
  margin-bottom: 0.615rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};
`;

export const DivWrapper = styled.div`
  margin-bottom: 1.846rem;

  &.disabled {
    ${DropdownToggle} {
      pointer-events: none;
      border: 1px solid ${theme.colors.textDisabled} !important;
      color: ${theme.colors.textDisabled} !important;
    }
    ${SpanArrow} {
      color: ${theme.colors.textDisabled} !important;
    }
  }
`;
